import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import * as _4 from 'lodash4';

export function SurveyRoutes($stateProvider: ng.ui.IStateProvider) {
  const surveyRouteResolve = {
    accountModelData: (
      accountModel: AccountModel,
      loadAccountCommand: ICommand,
      loadSurveyCommand: ICommand,
      $stateParams: ng.ui.IStateParamsService
    ) => {
      if (_4.isEmpty(accountModel.student_nk)) {
        return loadAccountCommand().then(() => loadSurveyCommand($stateParams.surveyID));
      } else {
        return loadSurveyCommand($stateParams.surveyID);
      }
    }
  };

  $stateProvider
    .state('my.survey-intro', {
      url: 'surveys/{surveyID:int}/survey-intro',
      templateUrl: 'capability-ng-survey/src/views/survey_introduction/survey_introduction.html',
      controller: 'SurveyIntroductionController',
      controllerAs: '$ctrl',
      params: {
        methodType: undefined,
        recipientID: undefined
      },
      data: {
        viewTitle: 'Survey Introduction',
        ignoredInHistory: true
      },
      resolve: surveyRouteResolve
    })
    .state('my.survey-question', {
      url: 'surveys/{surveyID:int}/survey-question',
      templateUrl: 'capability-ng-survey/src/views/survey_question/survey_question.html',
      controller: 'SurveyQuestionController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Survey Question',
        ignoredInHistory: true
      },
      resolve: surveyRouteResolve
    })
    .state('my.survey-summary', {
      url: 'surveys/{surveyID:int}/survey-summary',
      templateUrl: 'capability-ng-survey/src/views/survey_summary/survey_summary.html',
      controller: 'SurveySummaryController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Survey Summary'
      },
      resolve: surveyRouteResolve
    });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/survey_routes.ts